define('score_bootstrap/Components/ContentSearch/SearchResults',[
    "jquery",
    "knockout",
    "eventManager",
    "score_bootstrap/Components/ContentSearch/SearchResultsBase",
    "score_bootstrap/Models/Tile",
    "score_bootstrap/Models/Search/PromoTile",
    "score_bootstrap/Models/Search/SearchRequest",
    "score_bootstrap/Events/SearchResponseEvent",
    "imagesLoaded",
    "score_bootstrap/Utils/UrlHelper",
    "matchHeight"
], function (
    $,
    ko,
    eventManager,
    SearchResultsBase,
    Tile,
    PromoTile,
    SearchRequest,
    SearchResponseEvent,
    imagesLoaded,
    urlHelper
) {
    "use strict";

    var tileCache = {};

    function SearchResults(scope, uniqueId, refreshEvents, showMessages, isLazySearch, tileName, switchToClassicPager, classicPagesToDisplay, showEllipsisInBetween, scrollToPageTop) {
        var promoTiles = $(".score-promo-tile", scope).remove().toArray().map(PromoTile.fromElement).sort(PromoTile.sort),
            includeMatchHeight = true;

        this.query = ko.observable("");
        this.serviceUnavailable = ko.observable(false);
        this.results = ko.observableArray([]);
        this.numberOfResults = ko.observable("");
        this.canShowMore = ko.observable(false);
        this.currentPage = ko.observable(0);
        this.allPages = ko.observableArray([]);
        this.showLazySearchMessage = ko.observable(isLazySearch);
        this.totalPages = ko.observable(0);
        this.showPager = ko.observable(false);
        this.isPageReload = false;

        Object.defineProperties(this, {
            promoTiles: { enumerable: false, value: promoTiles },
            tileName: { enumerable: true, value: tileName },
            tilesPerRow: {
                enumerable: false,
                get: function () {
                    return SearchResultsBase.howManyTilesPerRow(this.$list);
                }
            },
            includeMatchHeight: {
                enumerable: false,
                get: function () { return includeMatchHeight; },
                set: function (val) { includeMatchHeight = val; }
            },
            switchToClassicPager: { enumerable: !1, value: !!switchToClassicPager },
            classicPagesToDisplay: { enumerable: !1, value: classicPagesToDisplay | 0 },
            showEllipsisInBetween: { enumerable: !1, value: !!showEllipsisInBetween },
            scrollToPageTop: { enumerable: !1, value: !!scrollToPageTop },
            initialResultLoaded: {enumerable: !1, value: !1, writable: !0}
        });

        // Append some client logic during the initial search loading
        var subscription = eventManager.subscribe("ModulesLoadedEvent", function (ev) {
            var pageNumber = urlHelper.getHashValue(this.id + "page") | 0;
            if (pageNumber > 0) {
                if (!this.switchToClassicPager) {
                    this.reloadPage(pageNumber, false);
                }
            }
        }.bind(this));

        ko.applyBindings(this, scope);

        SearchResultsBase.call(this, scope, uniqueId, isLazySearch, refreshEvents, showMessages);
        tileCache[this.id] = {};

        window.addEventListener('hashchange', (function () {
            var pageNumber = urlHelper.getHashValue(this.id + "page") | 0;
            //execute only if back/forward button is clicked
            if (pageNumber != this.searchClient.searchRequest.page) {
                if (!this.switchToClassicPager) {
                    this.reloadPage(pageNumber, true);
                } else {
                    this.showPage(pageNumber);
                }
            }
        }).bind(this));
    }

    SearchResults.prototype = Object.create(SearchResultsBase.prototype);

    SearchResults.prototype.resetResults = function resetResults() {
        this.$list.empty();
        this.results.removeAll();
        this.allPages.removeAll();
    }

    SearchResults.prototype.reset = function reset() {
        this.resetResults();
        this.currentPage(0);
        this.page = 0;
    }

    SearchResults.prototype.appendTiles = function appendTiles(response) {
        var newTiles = [], lastRowTiles = [], self = this;

        this.serviceUnavailable(false);


        var pageNumber = urlHelper.getHashValue(this.id + "page") | 0;
        if (response.page !== pageNumber && !this.isPageReload) {
            urlHelper.setHashValue(window.location, this.id + "page", String(response.page));
        }

        if (response.page <= this.page) {
            // When there is a new search response, current tiles should always be cleared out first,
            // unless the 'page' value has been incremeneted, which means that 'show more' was clicked
            this.resetResults();
        } else {
            // 'show more' was clicked, so page should be incremented
            this.page = response.page;

            lastRowTiles = SearchResultsBase.getLastRowTiles(this);
        }

        var originalQuantity = this.tiles.length;

        response.items.forEach(function (item) {
            var id = item.id.toString(), tile, cache = tileCache[this.id];

            if (!cache.hasOwnProperty(id)) {
                cache[id] = new Tile(item, this.tileName);
            }

            tile = cache[id];
            this.results.push(tile);
            newTiles.push(tile.element());
        }, this);

        // store amount pages for a classic pager
        this.totalPages(response.totalPages);
        this.currentPage(response.page);
        this.allPages.removeAll();
        Array.apply(null, { length: response.totalPages }).map((function (v, i) { this.allPages.push(i); }).bind(this));
        this.showPager(response.totalPages > 1 && this.switchToClassicPager);


        this.canShowMore((response.page + 1) < response.totalPages);
        this.numberOfResults(response.totalItems);
        this.query(response.query);

        if (!newTiles.length) {
            if ($(self.scope).hasClass("js-hide-on-load")) {
                $(self.scope).removeClass("js-hide-on-load");
            }
            return;
        }

        newTiles = $(newTiles).add(SearchResultsBase.injectPromoTiles(this, originalQuantity));

        if (!this.includeMatchHeight) {
            // Wait to run matchHeight until all the images are loaded since
            // height of images affect the height of the tiles
            imagesLoaded($("img", newTiles), function matchHeightOnNewTiles() {
                var emptySpots = self.tilesPerRow - lastRowTiles.length;
                if (emptySpots > 0) {
                    $(newTiles.slice(0, emptySpots)).add(lastRowTiles).matchHeight(true);
                    newTiles = newTiles.slice(emptySpots);
                }

                $(newTiles).matchHeight(true);
                if ($(self.scope).hasClass("js-hide-on-load")) {
                    $(self.scope).removeClass("js-hide-on-load");
                }
            });
        }

        // explicitly providing hook to tenants for search rendering
        eventManager.trigger("search-rendered", this.scope, response.page|0, response.perPage|0, response.totalItems|0, this.tileName);

        // call base class implementation
        SearchResultsBase.prototype.appendTiles.call(this);

        if ($(self.scope).hasClass("js-hide-on-load")) {
            $(self.scope).removeClass("js-hide-on-load");
        }

        if (this.initialResultLoaded && this.scrollToPageTop) {
            this.scrollToTopResults();
        }

        // setup the initial release was loaded
        this.initialResultLoaded = !0;
    };

    SearchResults.prototype.getPages = function getPages() {
        if (this.totalPages() <= this.classicPagesToDisplay || this.classicPagesToDisplay <= 0) {
            return this.allPages();
        } else {
            var first = 0,
                ellipsisLimit = 3,
                currentPage = this.currentPage(),
                totalPages = this.totalPages();

            var upperLimit = currentPage + 1;
            if (this.showEllipsisInBetween && totalPages - upperLimit === ellipsisLimit) {
                upperLimit++;
            }

            var downLimit = currentPage - 1;
            if (this.showEllipsisInBetween && currentPage === ellipsisLimit) {
                downLimit--;
            }

            while (upperLimit >= totalPages) {
                upperLimit--;
                if (downLimit > first)
                    downLimit--;
            }

            while (downLimit < first) {
                downLimit++;
                if (upperLimit < totalPages)
                    upperLimit++;
            }

            var pages = [];
            for (var i = downLimit; i <= upperLimit; i++) {
                pages.push(i);
            }

            return ko.observableArray(pages);
        }
    };


    SearchResults.prototype.reloadPage = function reloadPage(pageNumber, forceReload) {
        var tilesPerPage = this.searchClient.searchRequest.perPage;
        var currentPage = parseInt(pageNumber) | 0;
        this.searchClient.searchRequest.perPage = parseInt(tilesPerPage) * (currentPage + 1);
        this.searchClient.searchRequest.page = 0;
        this.searchClient.searchRequest.startPage = 0;
        this.page = 0;
        this.isPageReload = true;
        // Get back the parameters after initial page loading
        var pageLoadedSubscription = eventManager.subscribe("SearchResponseEvent:pageLoaded", function (data) {
            this.searchClient.searchRequest.perPage = tilesPerPage;
            this.searchClient.searchRequest.page = currentPage;
            this.searchClient.searchRequest.startPage = currentPage;
            this.page = currentPage;
            // Ensure that this event handler is called only once
            eventManager.unsubscribe(pageLoadedSubscription);
            this.isPageReload = false;
        }.bind(this));

        if (forceReload) {
            var searchProm = this.searchClient.search().done(this.searchClient.triggerSearchResponseEvent);
        }
    }

    SearchResults.prototype.showPage = function showPage(pageNumber) {
        var searchClient = this.searchClient,
            newPage = pageNumber|0;

        searchClient.searchRequest.page = newPage;
        searchClient.searchRequest.startPage = newPage;

        //urlHelper.setHashValue(window.location, this.id + "page", newPage);

        var searchProm = searchClient.search();
        searchProm.done((function() { this.results.removeAll(); }).bind(this));
        searchProm.done(this.appendTiles.bind(this));
    }

    SearchResults.prototype.showLeftBoundary = function showLeftBoundary() {
        var leftArr = this.getPages().slice(0, 1);
        return leftArr[0] !== 0 && (!this.showEllipsisInBetween || leftArr[0] !== 1);
    }

    SearchResults.prototype.showRightBoundary = function showRightBoundary() {
        var leftArr = this.getPages().slice(-1);
        return leftArr[0] < (this.totalPages() - 1) && (!this.showEllipsisInBetween || leftArr[0] < (this.totalPages() - 2));
    }

    SearchResults.prototype.showPrevPage = function showPrevPage() {
        if (this.currentPage() - 1 >= 0) {
            this.showPage(this.currentPage() - 1);
        }
    }

    SearchResults.prototype.showNextPage = function showNextPage() {
        if (this.currentPage() + 1 < this.totalPages()) {
            this.showPage(this.currentPage() + 1);
        }
    }

    SearchResults.prototype.showFirstPage = function showFirstPage() {
        return this.getPages().slice(0, 1)[0] !== 0;
    }

    SearchResults.prototype.showLastPage = function showFirstPage() {
        return this.getPages().slice(-1)[0] < (this.totalPages() - 1);
    }

    SearchResults.prototype.showLastButOnePage = function showLastButOnePage() {
        return !this.showFirstPage() && this.getPages().slice(-1)[0] < (this.totalPages() - 3);
    }

    SearchResults.prototype.firstPageText = function firstPageText() {
        return "1";
    }

    SearchResults.prototype.lastPageText = function lastPageText() {
        return this.totalPages();
    }

    SearchResults.prototype.lastButOnePageText = function lastPageText() {
        return this.totalPages() - 1;
    }

    SearchResults.init = function init(args) {
        if (args.IsEditorEditing === true) {
            $(args.scope).removeClass("js-hide-on-load");
            return null;
        }

        return new SearchResults(
            args.scope,
            args.UniqueId,
            args.RefreshActionMessages || [],
            args.ShowMessagesTransmitting || [],
            args.LazySearch,
            args.TileName,
            args.SwitchToClassicPager,
            args.ClassicPagerButtonsToDisplay,
            args.ShowPagerEllipsisInBetween,
            args.ScrollToPageTop);
    };

    return SearchResults;
});
